import LegalDocument from '../components/LegalDocument'

const PrivacyPage = () => <LegalDocument document='privacy' />

export default PrivacyPage
